import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop, omit } from 'lodash/fp';
import withRestProps from 'helpers/withRestProps';
import { InputBoxControl } from 'components/forms/InputBox';

const propTypes = {
  type: PropTypes.oneOf(['radio', 'checkbox']).isRequired,
  input: PropTypes.object.isRequired,
  option: PropTypes.object.isRequired,
  rest: PropTypes.object,
  onChanged: PropTypes.func,
};

class Item extends PureComponent {
  static propTypes = propTypes;

  static defaultProps = {
    onChanged: noop,
  };

  getInputProps() {
    const { type, input, option } = this.props;
    const { disabled } = option;

    const props = {
      ...input,
      onChange: this.handleChange,
      disabled: !!disabled,
    };

    if (type === 'checkbox') {
      const value = input.value || {};
      const checked = !!value[option.name];

      return { ...props, checked, value };
    } else if (type === 'radio') {
      const { value } = option;
      const checked = input.value === value;

      return { ...props, checked, value };
    }

    return props;
  }

  handleChange = () => {
    const { type, input, option, onChanged } = this.props;

    let { value } = this.getInputProps();

    if (type === 'checkbox') {
      const { name } = option;
      const checked = !value[name];

      if (!checked) {
        value = omit([name], value);
      } else {
        value = { ...value, [name]: checked };
      }
    }

    input.onChange(value);

    onChanged(value);
  };

  render() {
    const { type, option, rest } = this.props;

    return (
      <InputBoxControl
        {...rest}
        required={false}
        {...option}
        type={type}
        input={this.getInputProps()}
      />
    );
  }
}

export default withRestProps()(Item);
